import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../endpoints';

export interface FinancialTransaction {
  id: string;
  type: 'profit' | 'expense' | 'income';
  amount: number;
  paidTo: string;
  description: string;
  referenceId: string;
  periodFrom: string;
  periodTo: string;
  netAccountBalanceAfter: number;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface FinancialStats {
  totalIncome: number;
  totalProfit: number;
  totalExpenses: number;
  todayIncome: number;
  todayProfit: number;
  todayExpenses: number;
  netAccountBalance: number;
  todayNetAccountBalance: number;
  monthlyData: Array<{
    month: string;
    profit: number;
    expense: number;
    income: number;
  }>;
}

export interface CreateFinancialData {
  type: 'profit' | 'expense' | 'income';
  amount: number;
  paidTo: string;
  description: string;
  periodFromDate: string;
  periodFromTime: string;
  periodToDate: string;
  periodToTime: string;
}

export interface FinancialResponse {
  transactions: FinancialTransaction[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export interface GetFinancialParams {
  page?: number;
  limit?: number;
  type?: 'all' | 'profit' | 'expense' | 'income';
  search?: string;
  fromDate?: string;
  fromTime?: string;
  toDate?: string;
  toTime?: string;
}

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
  message?: string;
}

class FinancialService {
  async getAll(params: GetFinancialParams = {}): Promise<FinancialResponse> {
    const res = await apiClient.get<ApiEnvelope<FinancialResponse>>(
      API_ENDPOINTS.FINANCIAL.GET_ALL,
      { params }
    );
    return res.data.data;
  }

  async getOne(id: string): Promise<FinancialTransaction> {
    const res = await apiClient.get<ApiEnvelope<FinancialTransaction>>(
      API_ENDPOINTS.FINANCIAL.GET_ONE(id)
    );
    return res.data.data;
  }

  async create(input: CreateFinancialData): Promise<FinancialTransaction> {
    const res = await apiClient.post<ApiEnvelope<FinancialTransaction>>(
      API_ENDPOINTS.FINANCIAL.CREATE,
      input
    );
    return res.data.data;
  }

  async getStats(): Promise<FinancialStats> {
    const res = await apiClient.get<ApiEnvelope<FinancialStats>>(
      API_ENDPOINTS.FINANCIAL.GET_STATS
    );
    return res.data.data;
  }
}

const financialService = new FinancialService();
export default financialService;